export default {
    LOAD_ACCOUNT_TYPE(state, account_type) {
        state.items = account_type
    }
}